<template>
  <b-modal id="modal-otorder" size="xl">
    <!--Content-->
    <template slot="modal-header">
      <div class>
        <!--Header-->
        <div></div>
      </div>
    </template>
    <div class="animated fadeIn">
      <b-row>
        <b-col lg="12">
          <!-- <b-card>
        <div slot="header">User Profile</div>-->
          <b-form>
            <b-row>
              <b-col md="6">
                <b-form-group>
                  <b-input-group>
                    <b-input-group-prepend>
                      <b-input-group-text class="standardizedWidth"
                        >Order ID</b-input-group-text
                      >
                    </b-input-group-prepend>
                    <b-form-input
                      v-model="order.order_edit.OrderID"
                      autocomplete="off"
                      type="text"
                      id="OrderID"
                    ></b-form-input>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group>
                  <b-input-group>
                    <b-input-group-prepend>
                      <b-input-group-text class="standardizedWidth"
                        >Customer ID</b-input-group-text
                      >
                    </b-input-group-prepend>
                    <b-form-input
                      v-model="order.order_edit.CustomerID"
                      autocomplete="off"
                      type="text"
                      id="CustomerID"
                    ></b-form-input>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col md="6">
                <b-form-group>
                  <b-input-group>
                    <b-input-group-prepend>
                      <b-input-group-text class="standardizedWidth"
                        >WebCustomer ID</b-input-group-text
                      >
                    </b-input-group-prepend>
                    <b-form-input
                      v-model="order.order_edit.WebCustomerID"
                      autocomplete="off"
                      type="text"
                      id="WebCustomerID"
                    ></b-form-input>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group>
                  <b-input-group>
                    <b-input-group-prepend>
                      <b-input-group-text class="standardizedWidth"
                        >Quantity</b-input-group-text
                      >
                    </b-input-group-prepend>
                    <b-form-input
                      v-model="order.order_edit.Quantity"
                      autocomplete="off"
                      type="text"
                      id="Quantity"
                    ></b-form-input>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="6">
                <b-form-group>
                  <b-input-group>
                    <b-input-group-prepend>
                      <b-input-group-text class="standardizedWidth"
                        >CAP/IOV</b-input-group-text
                      >
                    </b-input-group-prepend>
                    <b-form-input
                      v-model="order.order_edit.CAP"
                      autocomplete="off"
                      type="text"
                      id="CAP"
                    ></b-form-input>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">&nbsp;</b-col>
            </b-row>

            <b-row>
              <b-col md="6">
                <b-form-group>
                  <b-input-group>
                    <b-input-group-prepend>
                      <b-input-group-text class="standardizedWidth"
                        >Delivered To</b-input-group-text
                      >
                    </b-input-group-prepend>
                    <b-form-input
                      v-model="order.order_edit.ship_name"
                      autocomplete="off"
                      type="text"
                      id="ship_name"
                    ></b-form-input>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group>
                  <b-input-group v-if="hasTrackingInfo">
                    <!-- <b-button variant="success" @click="LoadArtwork">Download Hi-Res PDF</b-button> -->
                    <a
                      :href="trackingLink"
                      target="_blank"
                      class="btn btn-orange"
                      style="width:250px;"
                      role="button"
                    >
                      Track this package
                      <i class="fa fa-search appendIcon"></i>
                    </a>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="6">
                <b-form-group>
                  <b-input-group>
                    <b-input-group-prepend>
                      <b-input-group-text class="standardizedWidth"
                        >Address</b-input-group-text
                      >
                    </b-input-group-prepend>
                    <b-form-input
                      v-model="order.order_edit.ship_address_1"
                      autocomplete="off"
                      type="text"
                      id="ship_address_1"
                    ></b-form-input>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group>
                  <b-input-group>
                    <b-input-group-prepend>
                      <b-input-group-text class="standardizedWidth"
                        >Ste./Bldg</b-input-group-text
                      >
                    </b-input-group-prepend>
                    <b-form-input
                      v-model="order.order_edit.ship_address_2"
                      autocomplete="off"
                      type="text"
                      id="ship_address_2"
                    ></b-form-input>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="6">
                <b-form-group>
                  <b-input-group>
                    <b-input-group-prepend>
                      <b-input-group-text class="standardizedWidth"
                        >City</b-input-group-text
                      >
                    </b-input-group-prepend>
                    <b-form-input
                      v-model="order.order_edit.ship_city"
                      autocomplete="off"
                      type="text"
                      id="ship_city"
                    ></b-form-input>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col md="3">
                <b-form-group>
                  <b-input-group>
                    <b-input-group-prepend>
                      <b-input-group-text class="standardizedWidth"
                        >State/Province</b-input-group-text
                      >
                    </b-input-group-prepend>
                    <b-form-input
                      v-model="order.order_edit.ship_state"
                      autocomplete="off"
                      type="text"
                      id="ship_state"
                    ></b-form-input>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col md="3">
                <b-form-group>
                  <b-input-group>
                    <b-input-group-prepend>
                      <b-input-group-text>Postal Code</b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input
                      v-model="order.order_edit.ship_postal_code"
                      autocomplete="off"
                      type="text"
                      id="ship_postal_code"
                    ></b-form-input>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="6">
                <b-form-group>
                  <b-input-group>
                    <b-input-group-prepend>
                      <b-input-group-text class="standardizedWidth"
                        >Country</b-input-group-text
                      >
                    </b-input-group-prepend>
                    <b-form-input
                      v-model="order.order_edit.ship_country"
                      autocomplete="off"
                      type="text"
                      id="ship_country"
                    ></b-form-input>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group>
                  <b-input-group>
                    <b-input-group-prepend>
                      <b-input-group-text class="standardizedWidth"
                        >Shipping Method</b-input-group-text
                      >
                    </b-input-group-prepend>
                    <b-form-input
                      v-model="order.order_edit.ship_method"
                      autocomplete="off"
                      type="text"
                      id="ship_method"
                    ></b-form-input>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="6">
                <b-form-group>
                  <b-input-group>
                    <!-- <div class="form-group form-actions" style="float:left;"> -->
                    <b-button
                      style="width:250px;"
                      variant="primary"
                      @click="$bvModal.hide('modal-otorder')"
                    >
                      <i class="fa fa-arrow-left"></i>
                      Close Order Detail
                    </b-button>
                  </b-input-group>
                </b-form-group>
                <!-- </div> -->
              </b-col>
              <b-col md="6">
                <b-form-group>
                  <b-input-group>
                    <!-- <b-button variant="success" @click="LoadArtwork">Download Hi-Res PDF</b-button> -->
                    <a
                      :href="artworkLink"
                      style="width:250px;"
                      target="_blank"
                      class="btn btn-success"
                      role="button"
                    >
                      Download IOV Artwork
                      <i class="fa fa-download appendIcon"></i>
                    </a>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">&nbsp;</b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <b-tabs>
                  <b-tab active>
                    <template slot="title">
                      <i class="fa fa-cog"></i>
                      <span class="ml-1">Production Activtiy</span>
                    </template>
                    <br />
                    <b-row v-if="n_user.n_current_user.IsProduction">
                      <b-col md="6">
                        <b-form-group>
                          <b-input-group>
                            <b-input-group-prepend>
                              <b-input-group-text class="standardizedWidth"
                                >Tracking Number</b-input-group-text
                              >
                            </b-input-group-prepend>
                            <b-form-input
                              v-model="order.order_edit.TrackingNumber"
                              autocomplete="off"
                              type="text"
                              id="TrackingNumber"
                              :disabled="hasShipped"
                            ></b-form-input>
                          </b-input-group>
                        </b-form-group>
                      </b-col>
                      <b-col md="3">
                        <b-form-group>
                          <b-form-checkbox-group
                            id="basicCheckboxes"
                            name="Checkboxes"
                            :plain="true"
                            v-model="isCouriered"
                            v-if="!hasShipped"
                            @change="setTracking($event)"
                          >
                            <b-form-checkbox value="true"
                              >Deliver to Buffini</b-form-checkbox
                            >
                          </b-form-checkbox-group>
                        </b-form-group>
                      </b-col>
                      <b-col md="3">
                        <b-form-group>
                          <b-input-group>
                            <!-- <div class="form-group form-actions" style="float:left;"> -->
                            <b-button
                              v-if="!hasShipped"
                              variant="primary"
                              size="sm"
                              :disabled="
                                order.order_edit.TrackingNumber == null ||
                                  order.order_edit.TrackingNumber.length == 0
                              "
                              @click="ll_close"
                            >
                              Confirm Shipment
                            </b-button>
                          </b-input-group>
                        </b-form-group>
                      </b-col>
                    </b-row>

                    <b-list-group>
                      <b-list-group-item>
                        <b-row>
                          <b-col md="2">
                            <b>Reference #</b>
                          </b-col>
                          <b-col md="3">
                            <b>Status Event</b>
                          </b-col>
                          <b-col md="3">
                            <b>Time Stamp</b>
                          </b-col>
                          <b-col md="3">
                            <b>Tracking Number</b>
                          </b-col>
                        </b-row>
                      </b-list-group-item>
                      <ProductionStatusRow
                        v-for="activity in order.order_edit.Activity"
                        :key="activity.ProductionStatusID"
                        :activity="activity"
                      />
                    </b-list-group>
                  </b-tab>
                </b-tabs>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">&nbsp;</b-col>
            </b-row>
          </b-form>
          <!-- </b-card> -->
        </b-col>
      </b-row>
    </div>
    <template slot="modal-footer">
      <div
        slot
        class="modal-footer justify-content-center"
        style="border:none;"
      >
        <b-button
          class="mr-2"
          type="submit"
          size="md"
          variant="primary"
          data-dismiss="modal"
          @click="$bvModal.hide('modal-otorder')"
          aria-label="Close"
          >Close</b-button
        >
      </div>
    </template>
  </b-modal>
</template>

<script>
import { mapState } from "vuex";
import ProductionStatusRow from "@/components/CustomRowComponents/ProductionStatusRow.vue";
export default {
  name: "OneTimeOrder",
  data() {
    return {
      selected: [],
      isCouriered: false,
      hasShipped: false
    };
  },
  methods: {
    back() {
      this.$router.go(-1);
    },
    loadArtwork() {},
    ll_close() {
      var _op = {
        OrderID: this.$store.state.order.order_edit.OrderID,
        Tracking: this.$store.state.order.order_edit.TrackingNumber
      };
      this.hasShipped = true;
      this.$store
        .dispatch("order/llCloseOTOrder", _op)
        .then(this.$bvModal.hide("modal-otorder"));
    },
    setTracking(event) {
      if (event.length > 0) {
        this.$store.state.order.order_edit.TrackingNumber = "COURIER";
      } else {
        this.$store.state.order.order_edit.TrackingNumber = null;
      }
    }
  },
  mounted() {},
  computed: {
    ...mapState(["order", "n_user"]),
    computeDisabledConfirm() {
      if (this.hasShipped || this.TrackingNumber == "") {
        return true;
      }
      return false;
    },
    artworkLink() {
      return (
        "https://proofs.icap-maker.com/GetHistoricalpdf.aspx?OrderID=" +
        this.$store.state.order.order_edit.OrderID
      );
    },
    hasTrackingInfo() {
      return this.$store.state.order.order_edit.TrackingNumber;
    },
    trackingLink() {
      return (
        "https://www.fedex.com/apps/fedextrack/index.html?tracknumbers=" +
        this.$store.state.order.order_edit.TrackingNumber
      );
    }
  },
  components: {
    ProductionStatusRow
  },
  watch: {
    "$store.state.order.order_edit.OrderID": function(newValue, oldValue) {
      if (this.$store.state.order.order_edit.TrackingNumber) {
        this.hasShipped = true;
        if (this.$store.state.order.order_edit.TrackingNumber == "COURIER") {
          this.isCouriered = true;
        }
      } else {
        this.hasShipped = false;
      }
    }
  }
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.input-group-text {
  color: #111;
}
</style>
